import { styled } from "@linaria/react";

import { PropsWithTheme, withTheme } from "@gx/dls/theme";
import { SourceArtifactResource } from "@gx/ts-contracts/services/source/resources/source_artifact_pb";

import SourceArtifactContentViewer from "@/pages/sources/components/edit/tabs/artifacts/components/SourceArtifactContentViewer";
import SourceArtifactContentViewerHeader from "@/pages/sources/components/edit/tabs/artifacts/components/SourceArtifactContentViewerHeader";

import { useDownloadSourceArtifactMutation } from "@/api/mutations/source-artifacts";

import { useDownloadFile } from "@/hooks/useDownloadFile";

interface SourceArtifactContentViewerDrawerProps {
  artifact: SourceArtifactResource;
  content: string | null;
  isLoading: boolean;
  error: Error | null;
  downloadUrl: string | null;
  onClose: () => void;
}

const SourceArtifactContentViewerDrawerWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
`);

const SourceArtifactContentViewerDrawerHeaderWrapper = withTheme(styled.div<PropsWithTheme>`
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.color.background.tertiary};
  border-radius: 6px 6px 0 0;
  border-bottom: 0.5px solid ${({ theme }) => theme.color.border.primary};
  width: 100%;
  flex-shrink: 0;
`);

const SourceArtifactContentViewerDrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`;

const SourceArtifactContentViewerDrawer = ({
  artifact,
  content,
  isLoading,
  error,
  downloadUrl,
  onClose,
}: SourceArtifactContentViewerDrawerProps) => {
  const { mutate: getDownloadUrl } = useDownloadSourceArtifactMutation();

  const handleDownload = useDownloadFile({
    getUrl: () => void getDownloadUrl({ artifactId: artifact.id }),
    filename: artifact.id,
    existingUrl: downloadUrl,
  });

  return (
    <SourceArtifactContentViewerDrawerWrapper>
      <SourceArtifactContentViewerDrawerHeaderWrapper>
        <SourceArtifactContentViewerHeader
          artifact={artifact}
          onDownload={handleDownload} // eslint-disable-line @typescript-eslint/no-misused-promises
          onClose={onClose}
        />
      </SourceArtifactContentViewerDrawerHeaderWrapper>
      <SourceArtifactContentViewerDrawerBody>
        <SourceArtifactContentViewer
          artifact={artifact}
          content={content}
          isLoading={isLoading}
          error={error}
        />
      </SourceArtifactContentViewerDrawerBody>
    </SourceArtifactContentViewerDrawerWrapper>
  );
};

export default SourceArtifactContentViewerDrawer;
